import { OwcIcon, OwcInput } from "@one/react";
import styled from "styled-components";
import moment from "moment";
import React, { useContext, useEffect, useCallback } from "react";
import ButtonActionBox from "../log-book-item-fillter/ButtonActionBox";
import LOGBOOK_LABEL from "../../../utils/constants/logbookLabel";
import { CustomFilterContext } from ".././custom-filter/context";
import ClearAll from ".././log-book-item-fillter/ClearAll";
import { fetchLogSheets } from ".././log-sheet/fetch-log-sheets";
import { fetchRunLogs } from ".././run-logs/fetch-run-logs";
import { PaginationContext } from "../../../components/shared/pagination/PaginationContext";
import ChangeButtonActionBox from ".././log-book-item-fillter/ChangeButtonActionBox";
import { fetchChangeLogSheets } from "../log-sheet/fetch-change-log-sheets";
import { logSheetItemsToSheet, runSheetItemsToPDF } from ".././log-sheet/log-sheet-export/log-sheet-items-to-sheet";
import { runSheetItemsToPDF as changeLogRunSheetItemsToPdf } from ".././log-sheet/log-sheet-export/change-log-items-to-sheet";
import { runLogsItemsToPDF, runLogsItemsToSheet } from ".././run-logs/run-logs-export/run-logs-items-to-sheet";
import { SearchTextContext } from ".././log-book-item-fillter/suggester/search-context/context";
import { OwcDatepicker } from "@one/react";
import { formTypes } from "../../../constants";
import { CoverSheetMainPageContext } from "../../cover-sheet/cover-sheet-main-page-context/context";
import { fetchAllLogs } from "../run-logs/fetch-all-logs";
import { allLogsItemsToPDF, allLogsItemsToSheet } from "../run-logs/run-logs-export/all-logs-items-to-sheet";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
const FilterBox = styled.div`
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  width: 100%;
`;
const RunLogsFilterStyled = styled.div`
  align-self: flex-start;
  display: flex;
  align-items: center;
  position: relative;

  .search-field,
  .equipment-model-select,
  .date-from-picker,
  .date-to-picker {
    flex: 0 0 auto;
    margin-right: 0.75rem;
  }
  .date-from-picker,
  .date-to-picker {
    & .MuiInput-input {
      width: 6em;
    }
  }

  .date-to-picker:last-child {
    margin-right: 0;
  }
  .search-field {
    flex: 1 1 auto;
  }
`;

const SearchFilterBar = ({ value, equipmentDetail }) => {
  const { inventoryId } = useParams();
  const {
    inputsState: { dateFrom, dateTo },
    dispatchAction
  } = useContext(CustomFilterContext);
  const { searchText, onSearchTextChange, onAppliedSearchTextChange, onLastSearchedValue } =
    useContext(SearchTextContext);
  const { logType } = useContext(CoverSheetMainPageContext);
  const { dispatchAction: paginationDispatch, fetching } = useContext(PaginationContext);

  const setDateCallback = useCallback(
    (key) => (value) => {
      if (Array.isArray(value?.detail) && (value?.detail).length > 0) {
        if (value?.detail[0] instanceof Date) {
          let dateFromTemp = moment(value?.detail[0]).format("YYYY-MM-DD");
          let dateToTemp = null;

          if ((value?.detail).length === 2) {
            dateToTemp = moment(value?.detail[1]).format("YYYY-MM-DD");
            dispatchAction({
              type: "setDateRange",
              payload: { dateFrom: dateFromTemp, dateTo: dateToTemp }
            });
          }
        }
      }
      if (Array.isArray(value?.detail) && (value?.detail).length === 2) {
        paginationDispatch({ type: "clearAll" });
        dispatchAction({ type: "applyInputsState" });
      }
      if (value?.detail === null) {
        dispatchAction({
          type: "setDateRange",
          payload: { dateFrom: null, dateTo: null }
        });
        paginationDispatch({ type: "clearAll" });
        dispatchAction({ type: "applyInputsState" });
      }
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  /**
   * clears state after change of the tab in the table
   */
  useEffect(() => {
    paginationDispatch({ type: "clearAll" });
    dispatchAction({
      type: "clearAllButDates"
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, logType]);

  /**
   * function that sends values on change of search box input to the searchContext
   * @param {*} ev
   */
  const onInputChange = (ev) => {
    onSearchTextChange(ev.detail);
    onLastSearchedValue(ev.detail);
  };

  const timeString = "T00:00:00";
  let TimeFormat =
    dateFrom === null && dateTo === null
      ? null
      : dateFrom !== null && dateTo === null
        ? [new Date(dateFrom + timeString)]
        : dateFrom !== null && dateTo !== null
          ? [new Date(dateFrom + timeString), new Date(dateTo + timeString)]
          : [dateFrom, dateTo];
  return (
    <FilterBox>
      <RunLogsFilterStyled>
        <>
          {/* search box */}
          <OwcInput
            autoFocus
            placeholder={"Search all columns"}
            disabled={fetching}
            onInputChange={onInputChange}
            style={{ marginRight: 8 }}
            value={searchText}
          >
            <div slot="prefix">
              <OwcIcon name="search" />
            </div>
            <div
              slot="suffix"
              style={{
                color: "var(--one-color-interaction-default-neutral-3)"
              }}
            >
              {searchText && (
                <OwcIcon
                  type="filled"
                  name="circle_clear"
                  onClick={() => {
                    onSearchTextChange("");
                    onAppliedSearchTextChange("");
                    // paginationDispatch({ type: "clearAll" });
                    // dispatchAction({
                    //   type: "clearAll"
                    // });
                  }}
                  style={{
                    cursor: "pointer"
                  }}
                />
              )}
            </div>
          </OwcInput>
        </>
        {/* dates box */}
        <OwcDatepicker
          autoClose
          hasClearIcon={dateFrom === null ? false : true}
          type={"range"}
          label={LOGBOOK_LABEL.SEARCH_FILTER.date_range}
          placeholder={"DD-MM-YYYY"}
          format="dd-MMM-yyyy"
          value={TimeFormat}
          onValueChange={setDateCallback("setDateRange")}
          style={{ marginRight: 10 }}
          invalidDateMessage={"Invalid date format"}
          disabled={fetching}
        />
        <ClearAll className="clear-all" />
      </RunLogsFilterStyled>
      <>
        {value !== formTypes.CHANGE_LOG && (
          <ButtonActionBox
            fetchingFn={
              value === formTypes.ACTION_LOG
                ? fetchLogSheets
                : value === formTypes.ALL_LOG
                  ? fetchAllLogs
                  : fetchRunLogs
            }
            dataTestId={
              value === formTypes.ACTION_LOG ? "log-sheet" : value === formTypes.ALL_LOG ? "all-log" : "run-log"
            }
            fileNamePrefix={
              value === formTypes.ACTION_LOG
                ? "action-logs-report"
                : value === formTypes.ALL_LOG
                  ? "all-logs-export"
                  : "run-logs-report"
            }
            mapFn={
              value === formTypes.ACTION_LOG
                ? logSheetItemsToSheet
                : value === formTypes.ALL_LOG
                  ? allLogsItemsToSheet
                  : runLogsItemsToSheet
            }
            raportTitle={
              value === formTypes.ACTION_LOG && inventoryId
                ? `Action log - ${equipmentDetail?.shortIdentifier}`
                : value === formTypes.ACTION_LOG
                  ? "Action log list"
                  : value === formTypes.ALL_LOG
                    ? `All logs list - ${equipmentDetail?.shortIdentifier}`
                    : inventoryId
                      ? `Run log - ${equipmentDetail?.shortIdentifier}`
                      : "Run log list"
            }
            dataTestIdPDF={
              value === formTypes.ACTION_LOG ? "log-sheet" : value === formTypes.ALL_LOG ? "all-log" : "run-log"
            }
            fetchingFnPDF={
              value === formTypes.ACTION_LOG
                ? fetchLogSheets
                : value === formTypes.ALL_LOG
                  ? fetchAllLogs
                  : fetchRunLogs
            }
            fileNamePrefixPDF={
              value === formTypes.ACTION_LOG
                ? "action-logs-report"
                : value === formTypes.ALL_LOG
                  ? "all-logs-report"
                  : "run-logs-report"
            }
            mapFnPDF={
              value === formTypes.ACTION_LOG
                ? runSheetItemsToPDF
                : value === formTypes.ALL_LOG
                  ? allLogsItemsToPDF
                  : runLogsItemsToPDF
            }
          />
        )}
        {value === formTypes.CHANGE_LOG && (
          <ChangeButtonActionBox
            dataTestId="change-logs"
            fetchingFn={fetchChangeLogSheets}
            mapSecondFn={changeLogRunSheetItemsToPdf}
            fileNamePrefix="change-logs-report"
            raportTitle={`Change log - ${equipmentDetail?.shortIdentifier}`}
          />
        )}
      </>
    </FilterBox>
  );
};

export default SearchFilterBar;
